var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
    big: _vm.size === 'big',
    small: _vm.size === 'small',
    error: _vm.type === 'error',
  },style:({ background: _vm.statusColor, color: _vm.statusColorText })},[_vm._v(_vm._s(_vm.statusName))])}
var staticRenderFns = []

export { render, staticRenderFns }